var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Vue } from 'vue-property-decorator';
import * as yup from 'yup';
var AddContractOtherValidationMixin = /** @class */ (function (_super) {
    __extends(AddContractOtherValidationMixin, _super);
    function AddContractOtherValidationMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AddContractOtherValidationMixin.prototype.normalizeInsuranceType = function (value) {
        return (value || '').toLowerCase().replace(/[_\s-]/g, '');
    };
    AddContractOtherValidationMixin.prototype.isTravelType = function (value) {
        return this.normalizeInsuranceType(value) === 'travel';
    };
    AddContractOtherValidationMixin.prototype.isPlateRequiredType = function (value) {
        var normalized = this.normalizeInsuranceType(value);
        return normalized === 'icbari' || normalized === 'icbariavto' || normalized === 'kasko';
    };
    Object.defineProperty(AddContractOtherValidationMixin.prototype, "validationSchema", {
        get: function () {
            var _this = this;
            var _a, _b;
            var t = ((_b = (_a = this.translations) === null || _a === void 0 ? void 0 : _a.add_contract) === null || _b === void 0 ? void 0 : _b.validation) || {};
            return yup.object().shape({
                insuranceType: yup
                    .string()
                    .required(t.insurance_type_required || 'Sığorta növünü seçin'),
                company: yup
                    .string()
                    .required(t.company_required || 'Sığorta şirkəti tələb olunur'),
                insured: yup
                    .string()
                    .trim()
                    .required(t.insured_required || 'Ad, Soyad')
                    .matches(/^(?!.*\d).+$/, t.insured_no_digits || 'Ad, Soyad sahəsində rəqəm ola bilməz'),
                contractNumber: yup
                    .string()
                    .trim()
                    .required(t.contract_number_required || 'Müqavilə nömrəsi tələb olunur')
                    .matches(/^[A-Za-z0-9\/\-\s]+$/, t.contract_number_numeric || 'Müqavilə nömrəsi düzgün formatda deyil'),
                premium: yup
                    .string()
                    .trim()
                    .required(t.premium_required || 'Sığorta haqqı tələb olunur')
                    .matches(/^\d+(\.\d{1,2})?$/, t.premium_numeric || 'Sığorta haqqı yalnız rəqəm olmalıdır (məs: 100 və ya 100.25)'),
                plate: yup
                    .string()
                    .trim()
                    .when('insuranceType', {
                    is: function (value) { return _this.isPlateRequiredType(value); },
                    then: function (schema) { return schema
                        .required(t.plate_required || 'Qeydiyyat nişanı tələb olunur')
                        .matches(/^\d{2}-[A-Z]{2}-\d{3}$/, t.plate_format || 'Qeydiyyat nişanı RR-XX-RRR formatında olmalıdır'); },
                    otherwise: function (schema) { return schema.notRequired(); },
                }),
                effectiveDate: yup
                    .string()
                    .when('insuranceType', {
                    is: function (value) { return !_this.isTravelType(value); },
                    then: function (schema) { return schema.required(t.effective_date_required || 'Qüvvəyə minmə tarixi tələb olunur'); },
                    otherwise: function (schema) { return schema.notRequired(); },
                }),
                travelStartDate: yup
                    .string()
                    .when('insuranceType', {
                    is: function (value) { return _this.isTravelType(value); },
                    then: function (schema) { return schema
                        .required(t.travel_start_date_required || 'Səfərin başlanğıcı tələb olunur')
                        .test('travel-start-min-date', t.travel_start_date_min || 'Səfərin başlanğıcı minimum 2018-01-01 ola bilər', function (value) { return !value || value >= '2018-01-01'; })
                        .test('travel-start-before-end', t.travel_start_date_before_end || 'Səfərin başlanğıcı səfərin sonundan böyük ola bilməz', function (value, context) {
                        var endDate = context.parent.travelEndDate;
                        if (!value || !endDate) {
                            return true;
                        }
                        return value <= endDate;
                    }); },
                    otherwise: function (schema) { return schema.notRequired(); },
                }),
                payed: yup
                    .string()
                    .required(t.payed_required || 'Ödəniş statusunu seçin'),
                travelEndDate: yup
                    .string()
                    .when('insuranceType', {
                    is: function (value) { return _this.isTravelType(value); },
                    then: function (schema) { return schema
                        .required(t.travel_end_date_required || 'Səfərin sonu tələb olunur')
                        .test('travel-end-after-start', t.travel_end_date_after_start || 'Səfərin sonu səfərin başlanğıcından kiçik ola bilməz', function (value, context) {
                        var startDate = context.parent.travelStartDate;
                        if (!value || !startDate) {
                            return true;
                        }
                        return value >= startDate;
                    }); },
                    otherwise: function (schema) { return schema.notRequired(); },
                }),
            });
        },
        enumerable: false,
        configurable: true
    });
    AddContractOtherValidationMixin.prototype.validateForm = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_1, errors_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.validationSchema.validate(this.form, { abortEarly: false })];
                    case 1:
                        _a.sent();
                        this.errors = {};
                        return [2 /*return*/, true];
                    case 2:
                        err_1 = _a.sent();
                        errors_1 = {};
                        if (err_1.inner) {
                            err_1.inner.forEach(function (error) {
                                if (!errors_1[error.path]) {
                                    errors_1[error.path] = error.message;
                                }
                            });
                        }
                        this.errors = errors_1;
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AddContractOtherValidationMixin = __decorate([
        Component
    ], AddContractOtherValidationMixin);
    return AddContractOtherValidationMixin;
}(Vue));
export default AddContractOtherValidationMixin;
